module.exports = __webpack_public_path__ + "img/icon_02.b2803f0.png";